import isEmpty from "lodash/isEmpty";
import { VerifyResultImageApi } from "~/types/models/dashboard";

interface LocalFile extends Blob {
  width?: number;
  height?: number;
}

type ServerFile = VerifyResultImageApi["meta"];

const isServerFile = (file: LocalFile | ServerFile): file is ServerFile =>
  !!(file as ServerFile).w && !!(file as ServerFile).h;

export const getFileKey = (file: VerifyResultImageApi["meta"] | LocalFile) => {
  if (isEmpty(file)) {
    return Math.floor(Math.random() * 1000).toString();
  }

  if (isServerFile(file)) {
    return `${file.w}:${file.h}:${file.size}`;
  }

  return `${file?.width}:${file?.height}:${file.size}`;
};
